﻿window.communication = function () {  
    return {
        syncJSON: function (requestMethod, requestUrl, data, callback) {
            console.log(requestMethod, requestUrl, data);

            $.ajax({
                type: requestMethod,
                async: false,
                url: requestUrl,
                contentType: "application/json",
                dataType: "json",
                data: data,
                success: function (msg) { callback(msg) },
                error: function (msg) { console.log('error : ' + msg.d); }
                //error: function (msg) { alert('error : ' + msg.d); }
            });
        },
    }
}();
